import { PropertyPin } from '../../data'
import { dotPinHtml, pinCardHtml } from './allPins'
import { OverlaySpec } from './googleStacking'

/* Toolkit map-all-pins port, Google provider (#1313; Leaflet shipped first in
   #855). The pure halves — page dedupe, dot + card HTML — come from
   allPins.ts unchanged; this module owns only the Google glue: the
   OverlaySpec a dot rides into GoogleMap.tsx's BadgeOverlay factory (#1309),
   and the tooltip wrapper the compact click card opens with (the same markup
   LeafletMap builds inline around pinCardHtml). */

/** Dots sit UNDER the price badges — a dot must never occlude a real pin
 *  (Leaflet: zIndexOffset -200). Overlay containers are positioned children
 *  of one overlay pane, so a negative z-index orders within that pane only. */
export const DOT_PIN_Z_INDEX = -200

/** The compact card is 220px wide vs the 300px property popup: its tooltip
 *  centers on the dot at -110px, like Leaflet's 110-vs-150 popup offset. */
export const PIN_CARD_LEFT_PX = -110

export function dotPinSpec(pin: PropertyPin, onClick: () => void): OverlaySpec {
  return {
    lat: pin.lat,
    lng: pin.lng,
    html: dotPinHtml(pin),
    // The Leaflet divIcon wrapper class — explorer.css styles dot + hover on it.
    className: 'hfse-allpins-marker',
    // Center the 14px dot on the coordinate (Leaflet: iconAnchor [8, 8]).
    centered: true,
    zIndex: DOT_PIN_Z_INDEX,
    onClick,
  }
}

export function pinCardTooltipHtml(pin: PropertyPin, pdpUrl: string | null): string {
  return `<div class="hfse-allpins-tooltip"><div class="hfse-map-tooltip-content">${pinCardHtml(pin, pdpUrl)}</div></div>`
}
